// @ts-check
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import Icon from 'components/base/Icon';
import { FilterChip } from '@linearb/linui-common';
import { LBButton } from '@linearb/buzz';

const BtnNew = ({ toggleServiceFormModal }) => {
  return (
    <LBButton
      data-cy='btn-new-service'
      onClick={e => {
        e.stopPropagation();
        toggleServiceFormModal();
      }}
    >
      <Icon color='catskillWhite' name='Add' /> Add a Service
    </LBButton>
  );
};

const ServicesHeader = ({
  services = [],
  toggleServiceFormModal,
  readonly,
  selectionProps
}) => {
  const isSelectedOnlyMode =
    selectionProps?.isSelectedOnly && selectionProps?.setIsSelectedOnly;

  return (
    <Flex
      direction='row'
      justify='space-between'
      content='flex-start'
      items='center'
      data-cy='services-header'
    >
      <Flex direction='column'>
        <Flex items='center'>
          <Text size='large' weight='500'>
            {services.length} SERVICES
          </Text>
          {isSelectedOnlyMode && (
            <FilterChip
              sx={{ marginLeft: '1.5rem' }}
              height='1rem'
              label='Selected services'
              deleteIcon={<Icon name='Close' />}
              onDelete={() => selectionProps.setIsSelectedOnly(false)}
            />
          )}
        </Flex>
        <Text size='large' pb={SPACES.medium} pt={SPACES.small}>
          Services are logical groupings of repositories and folders
        </Text>
      </Flex>
      {!readonly && (
        <Flex ml='auto'>
          <BtnNew toggleServiceFormModal={toggleServiceFormModal} />
        </Flex>
      )}
    </Flex>
  );
};

export default ServicesHeader;
